var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3897 22.2467C18.2136 22.2467 18.9705 22.0783 19.6604 21.7413C20.3503 21.4044 20.9236 20.9342 21.3801 20.3307C21.3801 20.3307 21.8738 19.5021 21.3504 19.126C20.827 18.7498 20.1592 19.35 20.1592 19.35C19.4644 20.2552 18.5412 20.7079 17.3897 20.7079C16.3772 20.7079 15.5235 20.3407 14.8286 19.6065C14.1337 18.8723 13.7863 17.9771 13.7863 16.9209C13.7863 15.8649 14.1337 14.9672 14.8286 14.2279C15.5235 13.4886 16.3772 13.119 17.3897 13.119C18.4617 13.119 19.375 13.5515 20.1294 14.4165C20.1294 14.4165 20.6823 15.0312 21.2567 14.589C21.8312 14.1467 21.3504 13.4509 21.3504 13.4509C20.8838 12.8675 20.3081 12.4099 19.6232 12.078C18.9382 11.746 18.1937 11.5801 17.3897 11.5801C15.9404 11.5801 14.7144 12.1006 13.7119 13.1416C12.7093 14.1826 12.208 15.4424 12.208 16.9209C12.208 18.3995 12.7093 19.6568 13.7119 20.6927C14.7144 21.7288 15.9404 22.2467 17.3897 22.2467Z",
    fill: "#6CEFC2",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2.5098
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3053 25.1647C9.62583 26.4853 11.1053 27.4321 12.7436 28.0053C14.382 28.5785 16.044 28.7541 17.7297 28.5321C17.7297 28.5321 19.8304 28.0137 19.5861 26.5802C19.3419 25.1467 17.3228 25.025 17.3228 25.025C14.7783 25.3422 12.5833 24.5779 10.7377 22.7323C9.11484 21.1095 8.32682 19.161 8.37369 16.8867C8.4205 14.6125 9.27854 12.6407 10.9478 10.9715C12.6171 9.30219 14.5928 8.44014 16.875 8.38536C19.1573 8.33058 21.1098 9.11458 22.7326 10.7374C24.4509 12.4558 25.231 14.6031 25.073 17.1795C25.073 17.1795 24.9875 19.0373 26.6072 19.2589C28.227 19.4805 28.5561 17.6102 28.5561 17.6102C28.7304 15.9404 28.5309 14.2943 27.9578 12.6718C27.3846 11.0494 26.4537 9.59377 25.165 8.30505C22.8421 5.98219 20.0544 4.84 16.8021 4.87851C13.5497 4.91701 10.7551 6.10475 8.41812 8.44171C6.08112 10.7787 4.89736 13.5694 4.86681 16.8138C4.83626 20.0582 5.98242 22.8418 8.3053 25.1647Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.8198,
    y1: 15.4249,
    x2: 13.8015,
    y2: 23.9842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -2.79017,
    y1: 21.6817,
    x2: 18.6426,
    y2: 27.8732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C47C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthToken);
export default __webpack_public_path__ + "static/media/authToken.2fcbd8ef0576811f5ffb4f41e138da3b.svg";
export { ForwardRef as ReactComponent };